import { ChatOutlinedIcon, Flex, Loading, NoRowsOverlay } from '@shared/components';

import { ReviewResultCardBySubtask } from '../review-result-card-by-subtask';

interface Subtask {
  id: string;
  assignee: string;
  assigneeId: string;
  dueDate: Date | null;
  code: string;
}

interface QuestionReviewResultListProps {
  subtasks: Subtask[];
  taskId: string;
  questionId: string;
  loading?: boolean;
}

function EmptyState() {
  return (
    <Flex>
      <NoRowsOverlay
        icon={ChatOutlinedIcon}
        title='ยังไม่มีข้อมูลผลการรีวิว'
        slotProps={{
          title: {
            variant: 'h4',
          },
          icon: {
            color: 'secondary',
            fontSize: 48,
          },
          wrapper: {
            disablePadding: true,
            sx: (theme) => ({
              borderRadius: theme.shape.rounded(2),
              border: `1px dashed ${theme.palette.divider}`,
              bgcolor: theme.palette.grey[50],
              py: theme.spacing(6),
            }),
          },
        }}
      />
    </Flex>
  );
}

export default function QuestionReviewResultList(props: Readonly<QuestionReviewResultListProps>) {
  const { subtasks, taskId, questionId, loading } = props;

  if (loading) {
    return (
      <Loading
        sx={{
          minHeight: '200px',
          height: '100%',
        }}
      />
    );
  }

  if (subtasks.length === 0) {
    return <EmptyState />;
  }

  return subtasks.map((subtask, index) => (
    <ReviewResultCardBySubtask
      key={subtask.id}
      assignee={subtask.assignee}
      taskId={taskId}
      questionId={questionId}
      order={index + 1}
      taskCode={subtask.code}
      subtaskName={`ทบทวนข้อสอบครั้งที่ ${index + 1}`}
      subTaskId={subtask.id}
      dueDate={subtask.dueDate}
      assigneeId={subtask.assigneeId}
    />
  ));
}
